import {AlertEventObject, EventStoredObject, MarketData,} from "../../../@types/response";
import {useSelector} from "react-redux";
import Odds from "./Odds";
import {MODALS_TYPES} from "../../../constants/ModalsConstants";
import {useContext} from "react";
import {ModalsContext} from "../modals/ModalsContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch,} from "@fortawesome/free-solid-svg-icons";
import {getMarkets} from "../../../store/selectors/getMarkets";
import Tooltip from "../common/Tooltip";
import {EventModalProps} from "../../../@types/inputs";

export default function MonitorItem({alert, event}: { alert: AlertEventObject; event: EventStoredObject }) {
    const markets: MarketData = useSelector(getMarkets);

    const {setOpenedModalsCallback, setModalsDataCallback} = useContext(ModalsContext);

    const startDt = new Date(event.date);

    const label = `${event.category} - ${event.competition}`

    return (
            <tr
                    id={`alert-${alert.id}-${alert.marketId}-${alert.signId}`}
                    key={`alert-${alert.id}-${alert.marketId}-${alert.signId}`}
                    className={`border-b-2 tracking-[1px] border-black hover:bg-gray-600 bg-monitor-average`}
            >
                {/* event_name */}
                <td className="items-center 2xl:pl-28 pl-16 relative">
                    <div className={"border-r-[5px] absolute -left-2 2xl:mx-14 mx-8 2xl:h-12 h-9 "}></div>
                    <Tooltip isEvent={true} tooltipText={`${event.name} ${label}`}>
                        <div className="flex flex-col py-1 2xl:max-w-[30rem] max-w-xs">
                            <div
                                    className="text-left text-white truncate 2xl:text-monitorBase text-[0.68rem] font-medium "
                                    data-id="event-name"
                                    data-value={event.name}
                            >
                                {event.name}
                            </div>

                            <div
                                    className="text-left 2xl:text-monitorBase truncate text-[0.68rem]"
                                    data-id="competition"
                                    data-value={label.substring(0, 32)}
                            >
                                {label.substring(0, 32)}
                            </div>
                        </div>
                    </Tooltip>
                </td>
                {/*search*/}
                <td>
                <span
                        className="cursor-pointer"
                        onClick={() => {
                            const _event: EventModalProps = {id: event._id, name: event.name, sportId: event.sportId};
                            setModalsDataCallback(MODALS_TYPES.EVENT_DETAILS_MODAL, {event: _event});
                            setOpenedModalsCallback(MODALS_TYPES.EVENT_DETAILS_MODAL, true);
                        }}
                >
                    <FontAwesomeIcon icon={faSearch}/>
                </span>
                </td>
                {/* data */}
                <td
                        className="py-1 px-3 text-center"
                        data-id="event-time"
                        data-value={startDt.getTime()}
                >
                    {[
                        startDt.getDate().toString().padStart(2, "0"),
                        (startDt.getMonth() + 1).toString().padStart(2, "0"),
                    ].join("/")}
                    &nbsp;&nbsp;
                    {`${startDt.getHours().toString().padStart(2, "0")}:${startDt
                            .getMinutes()
                            .toString()
                            .padStart(2, "0")}`}
                </td>
                {/* market */}
                <td className="py-1 px-3 text-center">
                    {markets[alert.marketId]?.name}
                </td>
                {/* odds */}
                <td className="px-2 text-center relative btn-on-over">
                    <Odds odds={alert.odds} event={event}/>
                </td>
            </tr>
    );
}
